import React from 'react'
import { Segment, Statistic } from 'semantic-ui-react'

export default class OrderStatistic extends React.PureComponent {
  render() {
    const {
      maxOrderCount,
      minOrderCount,
      avgOrderCount,
      maxEarning,
      minEarning,
      avgEarning,
      dailyAvgEarning,
      avgCommission,
      allDriverCount,
      driverOrderUnderAverage,
      fullyFilledDriverCount,
    } = this.props

    const driverOrderStats = [
      {
        key: 'min-order',
        label: 'Minimum orders',
        value: minOrderCount,
      },
      {
        key: 'max-order',
        label: 'Maximum orders',
        value: maxOrderCount,
      },
      {
        key: 'avg-order',
        label: 'Average orders',
        value: avgOrderCount,
      },
      {
        key: 'active-driver',
        label: 'Active Driver',
        value: allDriverCount,
      },
      {
        key: 'daily-active-driver',
        label: 'Daily Active Driver',
        value: fullyFilledDriverCount,
      },
      {
        key: 'under-avg',
        label: 'Under Average',
        value: driverOrderUnderAverage,
      },
    ]

    const driverEarningStats = [
      {
        key: 'min-earning',
        label: 'Minimum earning',
        value: minEarning,
      },
      {
        key: 'max-earning',
        label: 'Maximum earning',
        value: maxEarning,
      },
      {
        key: 'avg-earning',
        label: 'Average earning',
        value: avgEarning,
      },
      {
        key: 'daily-avg-earning',
        label: 'Daily Average earning',
        value: dailyAvgEarning,
      },
      {
        key: 'avg-commission',
        label: 'Average Delivery commission',
        value: avgCommission,
      },
    ]

    return (
      <React.Fragment>
        <Segment>
          <Statistic.Group items={driverOrderStats} widths="six" />
        </Segment>
        <Segment>
          <Statistic.Group items={driverEarningStats} widths="five" />
        </Segment>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/driverStatistic.js